import { useState, useEffect } from 'react';

const useServiceWorker = (): ServiceWorkerRegistration | null => {
  const [serviceWorker, setServiceWorker] = useState<ServiceWorkerRegistration | null>(null);

  useEffect(() => {
    let cancelled = false;

    const getServiceWorker = async (): Promise<ServiceWorkerRegistration | null> => {
      if (!('serviceWorker' in navigator)) return null;

      try {
        return await navigator.serviceWorker.ready;
      } catch (_) {
        try {
          const registrations = await navigator.serviceWorker.getRegistrations();
          return registrations[0] ?? null;
        } catch (fallbackError) {
          console.error('Fallback service worker registration check failed:', fallbackError);
          return null;
        }
      }
    };

    void getServiceWorker().then((registration) => {
      if (!cancelled) setServiceWorker(registration);
    });

    return () => {
      cancelled = true;
    };
  }, []);

  return serviceWorker;
};

export default useServiceWorker;
